export function isNullOrUndefined(value: unknown): boolean {
  // Note difference from ===
  return value == null ? true : false
}

export function isDefined<T>(value: null | undefined | T): value is T {
  return !isNullOrUndefined(value)
}
